var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImages = function SvgImages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H6.75a1.5 1.5 0 0 0-1.5 1.5v1.5h-1.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-1.5h1.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5m-13.5 1.5h13.5v5.883l-.944-.943a1.5 1.5 0 0 0-2.122 0l-1.875 1.875-4.125-4.125a1.5 1.5 0 0 0-2.12 0L6.75 10.253zm10.5 13.5H3.75V8.25h1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h10.5zm3-3H6.75v-3.375L10.125 9l4.656 4.656a.75.75 0 0 0 1.06 0l2.406-2.406 2.003 2.004zM15 7.875a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
  })));
};
export default SvgImages;